import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { getLocalStorageMenuItem, getPopupBorderRaduis } from "../utility";
import { Button } from "@mui/material";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { ErrorOutline } from "@mui/icons-material";

const ErrorDialog = () => {
  const navigate = useNavigate();

  return (
    <Dialog
      open={true}
      fullWidth={true}
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: getPopupBorderRaduis(),
          backgroundColor:
            getLocalStorageMenuItem("mode") === "dark" ? "#1e1e1e" : "#fff",
        },
      }}
      slotProps={{
        backdrop: {
          timeout: 500,
          style: { backgroundColor: getLocalStorageMenuItem("mode") === "dark" ? '#121212' : "#EAECF0" },
        },
      }}
      className="alignByLang"
    >
      <div className="p-24 text-center">
        <ErrorOutline
          fontSize="large"
          className="text-danger"
          sx={{ fontSize: 60 }}
        />
        <DialogTitle className="p-0 head-font primary-color mt-2">
          {t("An Error Occurred")}
        </DialogTitle>
        <DialogContent className="p-0">
          <DialogContentText id="alert-dialog-slide-description">
            <p className="sub-font primary-color">
              {t(
                "Internet connection error, please press the button to refresh the page"
              )}
            </p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="button-height-sm mx-1 head-font"
            variant="contained"
            color="error"
            onClick={() => navigate(0)}
            fullWidth
          >
            {t("Refresh")}
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default ErrorDialog;
